module.exports = __webpack_public_path__ + "resources/img/img_ontune_vm_sms_m.39eb9499b94b87266ff0b7df4157778e.png";